/**
 * Convert a string to a URL-friendly slug
 * @param {string} text - String to convert to slug
 * @returns {string} URL-friendly slug
 */
export const createSlug = (text) => {
  return text
    .toLowerCase()
    .replace(/[^\w ]+/g, '')
    .replace(/ +/g, '-');
};

/**
 * Find a trend by its slug
 * @param {Array} trends - Array of trend objects
 * @param {string} slug - Slug to search for
 * @returns {Object|null} Matching trend or null if not found
 */
export const findTrendBySlug = (trends, slug) => {
  if (!trends || trends.length === 0 || !slug) {
    return null;
  }
  return trends.find(trend => createSlug(trend.title) === slug) || null;
};

/**
 * Get URL for a trend
 * @param {Object} trend - Trend object
 * @returns {string} URL for the trend
 */
export const getTrendUrl = (trend) => {
  if (!trend || !trend.title) {
    return '/';
  }
  return `/trends/${createSlug(trend.title)}`;
};